"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnabledFormQuestionOptions = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const getQuestionConfig_1 = __importDefault(require("./getQuestionConfig"));
const getEnabledFormQuestionOptions = (question) => {
    switch (question.type) {
        case FormQuestionType_1.default.REPETITION: {
            return [];
        }
        case FormQuestionType_1.default.CHECK: {
            const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.CHECK, question);
            return [config.yes, config.no].filter(o => !!o.subQuestions.enabled);
        }
        case FormQuestionType_1.default.LIST: {
            const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.LIST, question);
            return config.options.filter(o => {
                return !!o.subQuestions.enabled;
            });
        }
        case FormQuestionType_1.default.NUMBER: {
            const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.NUMBER, question);
            return [config.lessThan, config.moreThan].filter(o => !!o.subQuestions.enabled);
        }
        case FormQuestionType_1.default.RATING: {
            const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.RATING, question);
            return Object.keys(config)
                .filter(s => /^rating\d$/.test(s) && config[s])
                .map(s => config[s])
                .filter(o => !!o.subQuestions.enabled);
        }
        default:
            return [];
    }
};
exports.getEnabledFormQuestionOptions = getEnabledFormQuestionOptions;
exports.default = exports.getEnabledFormQuestionOptions;
